import ApiService from '../../components/api_services/apiService.jsx';
import ActionMenu from '../../components/components/action_menu/ActionMenu.jsx';
import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { Calendar, ChevronRight } from 'lucide-react';
import { setMaxPages, setTotalCount, toggleCheckedItem } from '../../store/promoSlice';
import { API_PLAN_TO_UI, UI_PLAN_TO_API, UI_STATUS_TO_API, formatPromotionDate, formatPromotionPeriod } from './promoUtils.js';
import PromotionTransactionBadge from './PromotionTransactionBadge.jsx';

const mapApiPromotion = (promo) => ({
    id: promo.id,
    date: promo.createdAt,
    startsAt: promo.startsAt,
    endsAt: promo.endsAt,
    eventName: promo.eventName,
    organizer: promo.organizerName,
    organizerId: promo.organizerId,
    eventId: promo.eventId,
    promotionType: promo.planDisplayName || API_PLAN_TO_UI[promo.planType] || promo.planType,
    amount: Number(promo.amountPln || 0),
    transaction: promo.transaction,
    statusKey: promo.statusLabel || promo.status?.toLowerCase(),
    status: promo.transaction || promo.statusLabel || promo.status?.toLowerCase(),
    invoiceData: promo.invoiceData || null,
});

export const fetchPromotions = async (
    currentPage,
    sortBy,
    sortDirection,
    keyword,
    filters,
    dispatch,
    setRawPromotions
) => {
    const sortMap = {
        date: 'createdAt',
        amount: 'amount',
        id: 'id',
        promotionType: 'planType',
        status: 'status',
    };

    const status = filters?.status ? UI_STATUS_TO_API[filters.status] : null;
    const planType = filters?.promotionType ? UI_PLAN_TO_API[filters.promotionType] : null;

    const response = await ApiService.getPromotions(
        currentPage,
        10,
        sortMap[sortBy] || sortBy,
        sortDirection,
        keyword,
        status,
        planType
    );

    let promotions = (response.data || []).map(mapApiPromotion);

    if (filters?.dateFrom) {
        const from = new Date(filters.dateFrom);
        promotions = promotions.filter((promo) => new Date(promo.date) >= from);
    }
    if (filters?.dateTo) {
        const to = new Date(filters.dateTo);
        to.setHours(23, 59, 59, 999);
        promotions = promotions.filter((promo) => new Date(promo.date) <= to);
    }

    dispatch(setTotalCount(response.totalItems || promotions.length));
    dispatch(setMaxPages(response.totalPages || 1));
    setRawPromotions(promotions);
};

export const mapPromotionsToRows = (promotions, checkedItems, dispatch, handlers = {}) => {
    return promotions.map((promo) => {
        const actionItems = [
            {
                key: 'renew',
                label: 'Ponów promowanie',
                icon: StatusUp,
                onClick: () => handlers.onRenew?.(promo),
            },
        ];

        if (promo.statusKey === 'scheduled') {
            actionItems.push({
                key: 'schedule',
                label: 'Zmień datę startu',
                icon: Calendar,
                onClick: () => handlers.onSchedule?.(promo),
            });
        }

        actionItems.push({
            key: 'delete',
            label: 'Usuń',
            icon: Trash,
            danger: true,
            onClick: () => handlers.onDelete?.(promo),
        });

        return [
        <input
            key={`check-${promo.id}`}
            type="checkbox"
            checked={checkedItems.includes(promo.id)}
            onChange={() => dispatch(toggleCheckedItem(promo.id))}
        />,
        <div key={`id-${promo.id}`}>{String(promo.id).slice(0, 8)}</div>,
        <div key={`date-${promo.id}`}>
            {formatPromotionDate(promo.date)}
        </div>,
        <div key={`event-${promo.id}`}>{promo.eventName}</div>,
        <div key={`type-${promo.id}`}>{promo.promotionType}</div>,
        <div key={`period-${promo.id}`} className="promo-period-cell">
            {formatPromotionPeriod(promo.startsAt, promo.endsAt)}
        </div>,
        <div key={`amount-${promo.id}`}>{promo.amount.toFixed(2)}</div>,
        <div key={`status-${promo.id}`} className="promo-status-cell">
            <PromotionTransactionBadge label={promo.status} />
        </div>,
        <div key={`actions-${promo.id}`} className="promo-history-actions">
            <ActionMenu
                items={actionItems}
                align="right"
                ariaLabel="Akcje promocji"
            />
            <button
                type="button"
                className="promo-row-nav-button"
                aria-label={`Szczegóły wydarzenia ${promo.eventName}`}
                onClick={() => handlers.onOpenEvent?.(promo)}
            >
                <ChevronRight size={20} />
            </button>
        </div>,
        ];
    });
};
